import * as ko from "knockout";
export class Postbox {
    pb: any;
    private static pb: any = new ko.subscribable();
    public static publisher() {
        return {
            subscribe: (handler, topic) => {
                Postbox.pb.subscribe(handler, null, topic);
            },
            publish: (message, topic) => {
                Postbox.pb.notifySubscribers(message, topic);
            }
        };
    }
}
export class PostboxPaging {
    private static pb = new ko.subscribable();
    private static subscriptions = new Map<string, ko.Subscription>();
    public static publisher() {
        return {
            subscribe: (handler: (message: any) => void, topic: string) => {
                if (PostboxPaging.subscriptions.has(topic)) {
                    return;
                }
                const sub = PostboxPaging.pb.subscribe(handler, null, topic);
                PostboxPaging.subscriptions.set(topic, sub);
            },
            unsubscribe: (topic: string) => {
                const sub = PostboxPaging.subscriptions.get(topic);
                if (sub) {
                    sub.dispose();
                    PostboxPaging.subscriptions.delete(topic);
                }
            },
            publish: (message: any, topic: string) => {
                PostboxPaging.pb.notifySubscribers(message, topic);
            }
        };
    }
}
